import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { BreadcrumbWrapper } from './styled';
import CombinedBreadcrumbDropdown from './CombinedBreadcrumbDropdown';

interface PresetBreadcrumbProps {
  presetId: string;
  title?: string;
  isSharedSaved?: boolean;
}

const PresetBreadcrumb: React.FC<PresetBreadcrumbProps> = ({ presetId, title, isSharedSaved }) => {
  const navigate = useNavigate();
  const handleOverviewClick = (e) => {
    e.preventDefault();
    navigate('/app/app-insights/dashboard/overview');
  };

  const overviewBreadcrumbItem = {
    title: (
      <a onClick={handleOverviewClick}>
        <HomeOutlined style={{ marginRight: 6, fontSize: '16px' }} /> Overview
      </a>
    ),
  };

  const presetTitleItem = {
    title: <span style={{ fontSize: '15px', fontWeight: 500, color: '#222' }}>{title}</span>,
  };

  const combinedDropdownItem = {
    title: <CombinedBreadcrumbDropdown presetId={presetId} title={title} type="preset" />,
  };

  if (isSharedSaved) {
    return (
      <BreadcrumbWrapper>
        <Breadcrumb separator=">" items={[overviewBreadcrumbItem, presetTitleItem]} />
      </BreadcrumbWrapper>
    );
  }

  return (
    <BreadcrumbWrapper>
      <Breadcrumb separator=">" items={[overviewBreadcrumbItem, combinedDropdownItem]} />
    </BreadcrumbWrapper>
  );
};

export default PresetBreadcrumb;
